import api from './api';

export interface SystemConfig {
  config_key: string;
  config_value: string;
  description?: string;
  updated_at: string;
}

export interface SystemSummary {
  company: {
    name?: string;
    address?: string;
    phone?: string;
    email?: string;
    website?: string;
    tax_code?: string;
    license?: string;
    founded?: string;
  };
  system: {
    name?: string;
    version?: string;
    developer?: string;
    contact?: string;
  };
  warehouse: {
    name?: string;
    address?: string;
    manager?: string;
    phone?: string;
  };
}

export interface SystemConfigUpdate {
  config_key: string;
  config_value: string;
  description?: string;
}

export const systemService = {
  // Lấy tất cả cấu hình hệ thống
  getAllConfigs: async (): Promise<SystemConfig[]> => {
    const response = await api.get('/api/system');
    return response.data.data;
  },

  // Lấy cấu hình theo key
  getConfigByKey: async (key: string): Promise<SystemConfig> => {
    const response = await api.get(`/api/system/${key}`);
    return response.data.data;
  },

  // Cập nhật cấu hình
  updateConfig: async (key: string, config: { config_value: string; description?: string }): Promise<void> => {
    await api.put(`/api/system/${key}`, config);
  },

  // Cập nhật nhiều cấu hình cùng lúc
  updateMultipleConfigs: async (configs: SystemConfigUpdate[]): Promise<{ updated_configs: string[] }> => {
    const response = await api.put('/api/system', { configs });
    return response.data.data;
  },

  // Thêm cấu hình mới
  createConfig: async (config: SystemConfigUpdate): Promise<{ id: number }> => {
    const response = await api.post('/api/system', config);
    return response.data.data;
  },

  // Xóa cấu hình
  deleteConfig: async (key: string): Promise<void> => {
    await api.delete(`/api/system/${key}`);
  },

  // Lấy thông tin tổng hợp hệ thống
  getSystemSummary: async (): Promise<SystemSummary> => {
    const response = await api.get('/api/system/info/summary');
    const data = response.data.data;
    // Đảm bảo tax_code được map đúng
    if (data.company && data.company.tax_code === undefined && data.company.company_tax_code !== undefined) {
      data.company.tax_code = data.company.company_tax_code;
    }
    return data;
  },

  // Lấy thông tin công ty
  getCompanyInfo: async () => {
    const summary = await systemService.getSystemSummary();
    return summary.company;
  },

  // Lấy thông tin hệ thống
  getSystemInfo: async () => {
    const summary = await systemService.getSystemSummary();
    return summary.system;
  },

  // Lấy thông tin kho
  getWarehouseInfo: async () => {
    const summary = await systemService.getSystemSummary();
    return summary.warehouse;
  }
}; 